import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import AccountDropdown from '../../commonComponents/AccountDropdown'
import ReportDropdown from '../../commonComponents/ReportDropdown'

function ScoringNavbar(props) {
	const isAdmin = props.account === 'admin'
	return <Navbar bg="dark" variant="dark">
		<div style={{ width: '150px' }} />
		<Navbar.Brand href="/#/">Scoring Web</Navbar.Brand>
		{props.editable ? <>
			<Form>
				{
					props.hasStagesBeenLoaded ?
						<>
							<Button variant="secondary"
								onClick={props.onComplete}
								disabled={props.buttonDisabled}>
								完成
							</Button>
						</> : null
				}
			</Form>
		</> : null}
		{
			props.hasStagesBeenLoaded && props.hasAnswer ?
				<>
					<div style={{ width: '30px' }} />
					<input
						type="checkbox"
						id="showAnswer"
						name="showAnswer"
						value="showAnswer"
						disabled={props.enableShowAnswerCheckbox ? '' : 'disabled'}
						onChange={(e) => {
							props.onShowAnswerChecked(e.target.checked)
						}} />
					<Navbar.Text>顯示自動判讀</Navbar.Text>
				</> : null
		}
		{props.editable ? <>
			<Form>
				{
					props.hasStagesBeenLoaded ?
						<Navbar.Text style={{
							color: 'white',
							fontSize: '18px',
							margin: '0px 0px 0px 18px',
						}}>
							{/* 請確認全部判讀完成再按下完成按鈕 */}
						</Navbar.Text>
						: null
				}
			</Form>
		</> : null}
		{
			props.editable == 0 ?
				<>
					<div style={{ width: '30px' }} />
					<Navbar.Text>
						<ReportDropdown
							all_event={props.all_event}
							arousal_s={props.arousal_s}
							spo2_s={props.spo2_s}
							stage={props.stage}
							psgFileId={props.psgFileId}
							account={props.account}
							modeArr={props.modeArr}
							msevent={props.msevent}
							masterEvents={props.masterEvents}
							totalEpoch={props.totalEpoch}
							spo2_deast={props.spo2_deast}
							spo2_respiratory={props.spo2_respiratory}
							Mixed_Apnea_s={props.Mixed_Apnea_s}
							Obstructive_Apnea_s={props.Obstructive_Apnea_s}
							Central_Apnea_s={props.Central_Apnea_s}
							Hypopnea_s={props.Hypopnea_s}
							limb_r_s={props.limb_r_s}
						/>
					</Navbar.Text>
				</> : null
		}
		{
			props.editable ? <>
				<div style={{ width: '30px' }} />
				<Navbar.Text>{props.stateToShow}</Navbar.Text>
			</> : null
		}
		{
			isAdmin && !props.editable ?
				<>
					<div style={{ width: '30px' }} />
					<Button
						variant="warning"
						onClick={props.onRecalculateAllAgreements}
						disabled={props.recalculatingAgreements || props.downloadingBatchReports}>
						{props.recalculatingAgreements ? '重算中...' : '重算全部一致性'}
					</Button>
					<div style={{ width: '10px' }} />
					<Button
						variant="info"
						onClick={props.onDownloadBatchWorkshopReports}
						disabled={props.recalculatingAgreements || props.downloadingBatchReports}>
						{props.downloadingBatchReports ? '產生中...' : '批次產生報告'}
					</Button>
				</> : null
		}
		<div style={{ width: '150px' }} />
		{
			<Navbar.Text>{"慢波總時長：" + props.totalSWTimeEpoch + " 秒"}</Navbar.Text>
		}
		<Navbar.Collapse className="justify-content-end">
			<Navbar.Text>
				<AccountDropdown account={props.account} onLogout={props.onLogout} />
			</Navbar.Text>
			<div style={{ width: '150px' }} />
		</Navbar.Collapse>
	</Navbar>
}

export default ScoringNavbar
